export const ordered = (items) => Array.isArray(items) ? [...items].filter(i => i?.visible !== false).sort((a, b) => (a.order || 0) - (b.order || 0)) : [];

export const responsiveImage = (value, sizes) => {
  const v = String(value || '');
  // Pre-generated static assets in /media/techdesk/
  const staticWidths = { warehouse: 1800, attendance: 1200, team: 933, production: 1200, sales: 1200, reservation: 800 };
  const staticMatch = v.match(/^\/media\/techdesk\/(\w+)\.webp$/);
  if (staticMatch && staticWidths[staticMatch[1]]) {
    const max = staticWidths[staticMatch[1]];
    const candidates = [480, 960, 1440].filter((w, i, list) => i === 0 || Math.min(w, max) !== Math.min(list[i - 1], max));
    return { srcSet: candidates.map(w => `/media/techdesk/${staticMatch[1]}-${w}.webp ${Math.min(w, max)}w`).join(', '), sizes, decoding: 'async' };
  }
  // CMS images served by the backend (on-the-fly WebP variants via ?w=)
  const cms = v.match(/(?:https?:\/\/[^/]+)?(\/api\/cms\/images\/[^?#]+)/);
  if (cms) {
    const base = `${process.env.REACT_APP_BACKEND_URL}${cms[1]}`;
    const ws = [360, 720, 1280, 1920];
    return {
      src: `${base}?w=1280`,
      srcSet: ws.map(w => `${base}?w=${w} ${w}w`).join(', '),
      sizes: sizes || '100vw',
      decoding: 'async',
    };
  }
  return {};
};

export const text = value => {
  if (value == null) return '';
  if (typeof value === 'object') return text(value.text || value.title || value.label || '');
  return String(value).replace(/<br\s*\/?>|<\/p>/gi, '\n').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim();
};

export const mediaUrl = value => {
  if (!value) return '';
  // CMS images must follow the current backend, including images saved on an older host.
  const match = String(value).match(/(?:https?:\/\/[^/]+)?(\/api\/cms\/images\/[^?#]+)/);
  return match ? `${process.env.REACT_APP_BACKEND_URL}${match[1]}` : value;
};

export const navHref = item => {
  if (item.pageSlug) return `/${item.pageSlug.replace(/^\//, '')}`;
  if (item.targetBlockId) return `${item.targetPageSlug || '/'}#${item.targetBlockId}`;
  const href = item.href || item.link || '';
  if (item.isExternal && href && !/^(https?:|mailto:|tel:|\/|#)/.test(href)) return `https://${href}`;
  return href;
};

export const buttonHref = content => {
  const link = content.buttonLink || '';
  if (content.buttonLinkType === 'email' && !link.startsWith('mailto:')) return `mailto:${link}`;
  if (content.buttonLinkType === 'tel' && !link.startsWith('tel:')) return `tel:${link.replace(/\s/g, '')}`;
  return link;
};